<template>
  <Teleport to="body">
    <div
      v-if="modelValue"
      class="fixed inset-0 z-[30000] flex items-center justify-center bg-black/50"
      @click.self="handleDismiss"
    >
      <div class="bg-card border border-border rounded-[10px] shadow-[0_10px_40px_rgba(0,0,0,0.2)] w-full max-w-[420px] mx-4 overflow-hidden">
        <div class="px-6 py-4 bg-muted/20 border-b border-border">
          <p class="text-[16px] font-semibold text-foreground">影豆余额不足</p>
        </div>
        <div class="px-6 py-5">
          <p class="text-[14px] leading-[1.7] text-muted-foreground">当前影豆数量不足以解锁本次服务。为了不影响您的体验，建议及时补充。</p>
        </div>
        <div class="px-6 pb-5 flex items-center justify-end gap-3">
          <button
            type="button"
            class="h-9 px-4 rounded-[6px] border border-border text-[13px] text-foreground hover:bg-muted transition-colors"
            @click="handleDismiss"
          >
            暂不处理
          </button>
          <button
            type="button"
            class="h-9 px-4 rounded-[6px] bg-primary text-[13px] text-primary-foreground hover:opacity-90 transition-opacity"
            @click="handleRecharge"
          >
            立即充值
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
/**
 * 影豆余额不足提示弹窗。
 * 展示与跳转由同目录 {@link ensurePowerCost} 控制；本文件只负责 UI。
 */
defineProps<{
  /** 是否展示弹窗 */
  modelValue: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
  /** 点击立即充值 */
  (e: "recharge"): void;
  /** 点击暂不处理或关闭 */
  (e: "dismiss"): void;
}>();

/** 关闭弹窗且不跳转充值 */
const handleDismiss = () => {
  emit("update:modelValue", false);
  emit("dismiss");
};

/** 关闭弹窗并跳转会员中心充值页 */
const handleRecharge = () => {
  emit("update:modelValue", false);
  emit("recharge");
};
</script>
